import { render, staticRenderFns } from "./ShowFieldCorridorAwareness.vue?vue&type=template&id=448dba10&scoped=true&"
import script from "./ShowFieldCorridorAwareness.vue?vue&type=script&lang=js&"
export * from "./ShowFieldCorridorAwareness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448dba10",
  null
  
)

export default component.exports